module.exports = __webpack_public_path__ + "static/img/200237.0969e2c7.png";